import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, GuardResult, MaybeAsync, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})

export class GuardService implements CanActivate {
  authService = inject(AuthService);
  router = inject(Router);
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<GuardResult> {
    const isAuth = await this.authService.hasValidSession();
    return isAuth ? true : this.router.parseUrl('/login');
  }
}
